var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManual(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 332,
    height: 117,
    viewBox: "0 0 332 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2396_96728)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 38.5,
    width: 158,
    height: 40,
    rx: 8,
    fill: "#26333D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 58.5,
    r: 10.4167,
    fill: "#4C565D",
    stroke: "#26333D",
    strokeWidth: 0.833333
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2396_96728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61 50.5H35C33.3431 50.5 32 51.8431 32 53.5C32 55.1569 33.3431 56.5 35 56.5H61C62.6569 56.5 64 55.1569 64 53.5C64 51.8431 62.6569 50.5 61 50.5Z",
    fill: "#7F8585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79 60.5H35C33.3431 60.5 32 61.8431 32 63.5C32 65.1569 33.3431 66.5 35 66.5H79C80.6569 66.5 82 65.1569 82 63.5C82 61.8431 80.6569 60.5 79 60.5Z",
    fill: "#CBCDC2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M158.125 57.5L165.125 57.5C165.677 57.5 166.125 57.0523 166.125 56.5V19.5C166.125 18.9477 166.573 18.5 167.125 18.5H174.125",
    stroke: "#192634"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.125 98.5H167.125C166.573 98.5 166.125 98.0523 166.125 97.5V78.281V58.5C166.125 57.9477 165.677 57.5 165.125 57.5H158.125",
    stroke: "#192634"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174,
    y: 0.5,
    width: 158,
    height: 40,
    rx: 8,
    fill: "#26333D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192,
    cy: 20.5,
    r: 10.4167,
    fill: "#4C565D",
    stroke: "#26333D",
    strokeWidth: 0.833333
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2396_96728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235 12.5H209C207.343 12.5 206 13.8431 206 15.5C206 17.1569 207.343 18.5 209 18.5H235C236.657 18.5 238 17.1569 238 15.5C238 13.8431 236.657 12.5 235 12.5Z",
    fill: "#7F8585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253 22.5H209C207.343 22.5 206 23.8431 206 25.5C206 27.1569 207.343 28.5 209 28.5H253C254.657 28.5 256 27.1569 256 25.5C256 23.8431 254.657 22.5 253 22.5Z",
    fill: "#CBCDC2"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 174,
    y: 48.5,
    width: 158,
    height: 68,
    rx: 8,
    fill: "#26333D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192,
    cy: 68.5,
    r: 10.4167,
    fill: "#4C565D",
    stroke: "#26333D",
    strokeWidth: 0.833333
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_2396_96728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235 60.5H209C207.343 60.5 206 61.8431 206 63.5C206 65.1569 207.343 66.5 209 66.5H235C236.657 66.5 238 65.1569 238 63.5C238 61.8431 236.657 60.5 235 60.5Z",
    fill: "#7F8585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253 70.5H209C207.343 70.5 206 71.8431 206 73.5C206 75.1569 207.343 76.5 209 76.5H253C254.657 76.5 256 75.1569 256 73.5C256 71.8431 254.657 70.5 253 70.5Z",
    fill: "#CBCDC2"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 192,
    cy: 96.5,
    r: 10.4167,
    fill: "#4C565D",
    stroke: "#26333D",
    strokeWidth: 0.833333
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_2396_96728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235 88.5H209C207.343 88.5 206 89.8431 206 91.5C206 93.1569 207.343 94.5 209 94.5H235C236.657 94.5 238 93.1569 238 91.5C238 89.8431 236.657 88.5 235 88.5Z",
    fill: "#7F8585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253 98.5H209C207.343 98.5 206 99.8431 206 101.5C206 103.157 207.343 104.5 209 104.5H253C254.657 104.5 256 103.157 256 101.5C256 99.8431 254.657 98.5 253 98.5Z",
    fill: "#CBCDC2"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2396_96728"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 332,
    height: 116,
    fill: "white",
    transform: "translate(0 0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2396_96728"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 16,
    fill: "white",
    transform: "translate(32 50.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2396_96728"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 16,
    fill: "white",
    transform: "translate(206 12.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_2396_96728"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 16,
    fill: "white",
    transform: "translate(206 60.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_2396_96728"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 16,
    fill: "white",
    transform: "translate(206 88.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManual);
export default __webpack_public_path__ + "static/media/manual.c9c8a5d7fd86093689be110481cc63fc.svg";
export { ForwardRef as ReactComponent };